import {
  FACEBOOK_STORY_COMPOSER_ASPECT_RATIO,
  FACEBOOK_STORY_PHOTO_MAX_BYTES,
  FACEBOOK_STORY_VIDEO_MAX_SECONDS,
  FACEBOOK_STORY_VIDEO_MIN_HEIGHT,
  FACEBOOK_STORY_VIDEO_MIN_SECONDS,
  FACEBOOK_STORY_VIDEO_MIN_WIDTH,
} from "@dialogueconsulting/ig-content-publishing/constants";
import { AccountPlatformType } from "../shared/types/accounts";

export const VIDEO_REEL_CONSTANTS = {
  ASPECT_RATIO: {
    MIN_NINE_TO_SIXTEEN: 0.55,
    MAX_NINE_TO_SIXTEEN: 0.57,
  },
  DURATION: {
    MAX_REEL_SECONDS: 90,
  },
  SUPPORTED_PLATFORMS: ["FB"] as const satisfies readonly AccountPlatformType[],
  POST_TYPES: {
    VIDEO: "video",
    REEL: "reel",
  },
} as const;

export const FACEBOOK_STORY_CONSTANTS = {
  DURATION: {
    MIN_SECONDS: FACEBOOK_STORY_VIDEO_MIN_SECONDS,
    MAX_SECONDS: FACEBOOK_STORY_VIDEO_MAX_SECONDS,
  },
  MIN_VIDEO_WIDTH: FACEBOOK_STORY_VIDEO_MIN_WIDTH,
  MIN_VIDEO_HEIGHT: FACEBOOK_STORY_VIDEO_MIN_HEIGHT,
  ASPECT_RATIO: FACEBOOK_STORY_COMPOSER_ASPECT_RATIO,
  MAX_PHOTO_BYTES: FACEBOOK_STORY_PHOTO_MAX_BYTES,
  PHOTO_EXTENSIONS: [
    "jpg",
    "jpeg",
    "bmp",
    "png",
    "gif",
    "tif",
    "tiff",
    "webp",
    "heic",
    "heif",
    "avif",
  ],
} as const;

export type VideoPostType =
  (typeof VIDEO_REEL_CONSTANTS.POST_TYPES)[keyof typeof VIDEO_REEL_CONSTANTS.POST_TYPES];
